import { render, staticRenderFns } from "./news_detail.html?vue&type=template&id=57e735aa&scoped=true&"
import script from "./news_detail.vue?vue&type=script&lang=js&"
export * from "./news_detail.vue?vue&type=script&lang=js&"
import style0 from "./news_detail.scss?vue&type=style&index=0&id=57e735aa&scope=true&scoped=true&lang=scss&"
import style1 from "./news_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e735aa",
  null
  
)

export default component.exports